import { waMessages } from "@/lib/whatsapp";
import FaqAccordion, { type FaqItemData } from "@/components/feature/FaqAccordion";
import Reveal from "@/components/feature/Reveal";

const faqItems: FaqItemData[] = [
  {
    question: "Randevu talebimi nasıl iletebilirim?",
    answer:
      "Randevu talebinizi WhatsApp üzerinden iletebilirsiniz. Size en uygun gün ve saatleri birlikte belirlemek için bize yazmanız yeterli.",
    waMessage:
      "Merhaba gülaYonar, randevu talebimi iletmek istiyorum. Uygun gün ve saatler hakkında bilgi verebilir misiniz?",
  },
  {
    question: "İşlem fiyatını nasıl öğrenebilirim?",
    answer:
      "Her işlemin kapsamı kişiye göre değişebildiği için güncel ücret bilgisini salon ekibimizden öğrenebilirsiniz. Size en doğru bilgiyi vermek için işlem detaylarını birlikte konuşuruz.",
    waMessage:
      "Merhaba gülaYonar, bir işlemin güncel fiyatını öğrenmek istiyorum. Detayları paylaşabilir misiniz?",
  },
  {
    question: "Salonunuz nerede?",
    answer:
      "Salonumuz Odunluk Mahallesi, Akpınar Caddesi No: 13BA, Zorlu Plaza, Kat: 1, Daire: 2, Nilüfer / Bursa adresinde yer alıyor.",
    waMessage: waMessages.location,
  },
  {
    question: "Gelin hazırlığı hakkında nasıl bilgi alabilirim?",
    answer:
      "Gelin saçı ve özel gün hazırlığı hizmetlerimizle ilgili detayları WhatsApp üzerinden konuşabilirsiniz. Hayalinizdeki görünümü birlikte planlarız.",
    waMessage: waMessages.bridal,
  },
  {
    question: "Hangi bakımın bana uygun olduğunu nasıl öğrenebilirim?",
    answer:
      "Cildinizin ve saçınızın mevcut durumunu dinleyerek size en uygun bakım seçeneğini birlikte belirleriz. Kişiye uygunluk için salon ekibimizle görüşmenizi öneririz.",
    waMessage:
      "Merhaba gülaYonar, bana uygun bakım hizmetini öğrenmek istiyorum. Bilgi verebilir misiniz?",
  },
];

export default function Faq() {
  return (
    <section id="sss" className="scroll-mt-24 bg-background-100">
      <div className="mx-auto max-w-4xl px-4 py-16 md:px-6 md:py-24">
        <Reveal>
          <p className="text-xs uppercase tracking-[0.28em] text-accent-600 md:text-sm">
            Sık Sorulan Sorular
          </p>
          <h2 className="mt-4 font-heading text-3xl leading-tight text-primary-800 md:text-5xl">
            Merak ettikleriniz.
          </h2>
        </Reveal>

        <Reveal className="mt-10" delay={100}>
          <FaqAccordion items={faqItems} />
        </Reveal>
      </div>
    </section>
  );
}